var _rect, _path, _rect2, _rect3, _circle, _circle2, _circle3, _circle4, _rect4, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 300,
    viewBox: "0 0 400 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "carGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3b82f6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2563eb",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 150,
    width: 300,
    height: 100,
    rx: 10,
    fill: "url(#carGradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 150 L140 100 L260 100 L300 150 Z",
    fill: "url(#carGradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 110,
    width: 60,
    height: 35,
    rx: 3,
    fill: "rgba(255,255,255,0.3)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 110,
    width: 60,
    height: 35,
    rx: 3,
    fill: "rgba(255,255,255,0.3)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 260,
    r: 30,
    fill: "#1e293b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 260,
    r: 20,
    fill: "#64748b"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 260,
    r: 30,
    fill: "#1e293b"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 260,
    r: 20,
    fill: "#64748b"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 170,
    width: 30,
    height: 30,
    rx: 2,
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 192,
    fontFamily: "Arial",
    fontWeight: "bold",
    fontSize: 20,
    fill: "#ef4444",
    textAnchor: "middle"
  }, "L")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarPlaceholder);
export default __webpack_public_path__ + "static/media/car-placeholder.f8d414347d4e375236052116db1881e1.svg";
export { ForwardRef as ReactComponent };